import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import Helper from '../../../utilities/helper';
import { useOidc } from '@axa-fr/react-oidc';
import { Link } from 'react-router-dom';
import { FundingSourceCard } from '../../Resources/FundingSources/FundingSourceCard';
import { useFetchWrapper } from '../../../hooks/useFetchWrapper';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentBody } from '../../Shared/Content/ContentBody';

export interface IFundingSource {
    fundingSourceID: number
    fundingSourceName: string
    administratorName: fundingSourceAdministrators
    fundingSourceTypeName: string
    vehicleCategories: fundingSourceVehicleCategories
    eligibleCostsList: eligibleCostsList
    programOfferingDescription: string
    upcomingDeadlineDescription: string
    organizationTypes: organizationTypes
    sourceURL: string
}

export interface fundingSourceVehicleCategories {
    vehicleCategoryNames: string[]
}

export interface fundingSourceAdministrators {
    administratorNames: string[]
}

export interface organizationTypes {
    organizationTypeIDs: number[]
}

export interface eligibleCostsList {
    eligibleCosts: string[]
}
interface IIncentive {
    incentiveProgramID: number,
    incentiveProgramName: string,
    incentiveProgramNameShort: string,
    programOfferingDescription: string,
    finalFundingPeriodCloseDate: Date,
    costsCovered: string,
    isNational: boolean,
    state: string,
    incentiveTypeID: number,
    incentiveTypeName: string,
    administratorName: string,
    programAdministratorDescription: string
}
interface IProps {
    fleetID: string
}

export const FundingSources = ({ fleetID }: IProps) => {
    const { isAuthenticated } = useOidc();
    const fetchWrapper = useFetchWrapper();
    const [fundingSources, setFundingSources] = useState<IFundingSource[]>([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        getFundingSources();
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getFundingSources = () => {
        var fetchUrl = `Funding/FundingSources/${fleetID}`;

        fetchWrapper.get(fetchUrl)
            .then((data) => {
                if (data.success && data.fundingSources) {
                    setFundingSources(data.fundingSources);
                }
            });
    };

    return (
        <Row className="fundingSourcesContainer">
            <Col>
                <ContentBlock className="fundingSourcesSection componentPadding">
                    {fundingSources.length > 0 ? (
                        <ContentBody>
                            <h2 className="css_heading bold fundingSourcesTitle">
                                Funding Sources
                            </h2>
                            <div className="fundingSourcesTitle">
                                Based on the organization and vehicle type data selected, this fleet may be eligible for the following funding sources to help offset electrification capital costs:
                            </div>
                            {fundingSources.map((item: IFundingSource, index: number) => {
                                return (
                                    <Col sm={12} className="detailCol page-break-inside-avoid" key={index}>
                                        <FundingSourceCard fundingSourceItem={item} />
                                    </Col>
                                );
                            })}
                            <Row className="footerText">
                                {isAuthenticated ? (
                                    <Col lg={7} md={12} sm={12}>
                                        <div>
                                            <Link to='/FundingSources' target='_self' className="footerText">View our complete list</Link> of funding sources.
                                        </div>
                                    </Col>

                                ) : (
                                    <Col lg={8} md={12} sm={12}>
                                        <div>
                                            View our complete list of funding sources. <Button className="solidPos secondaryButton text-nowrap btn btn-secondary iconRightArrowBlue" href="/Login">GET ACCESS</Button>
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        </ContentBody>
                    ) : (
                            <ContentBody>
                                <h2 className="css_heading bold fundingSourcesTitle">
                                    Funding Sources
                                </h2>
                                <Card className="fundingSourcesCard">
                                    <CardBody>
                                        <Row>
                                            <Col className="fundingSourcesNoResultsText">
                                                <span className="bold">We didn't find any eligible funding sources for the selected organization and vehicle types, but funding eligibility is affected by many factors beyond what we collect for this estimate.</span>
                                                <p><Link className="accent-link" to="/ContactUs" target="_self">Contact us</Link> for a free, full fleet assessment which includes all the details we'll need to find your eligible funding sources.</p>
                                                {isAuthenticated ? (
                                                   <p>Not quite ready for a full fleet assessment? <Link className="accent-link" to="/FundingSources" target="_self">View our complete list</Link> of funding sources.</p>
                                                ) : (
                                                   <p>Not quite ready for a full fleet assessment? View our complete list of funding sources. <Button className="solidNeg tertiaryButton text-nowrap btn btn-secondary iconRightArrow" href="/Login">GET ACCESS</Button></p>
                                                        
                                                )}
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                        </ContentBody>
                    )}
                    
                </ContentBlock>
            </Col>
        </Row>
    )
}
